<template>
    <div
        class="tabs"
        :class="[{ isPoster: $store.state.user.can_post_offers }]"
        v-if="$vuetify.breakpoint.mdAndUp"
    >
        <template v-for="(step, i) in steps">
            <v-tab
                :key="step.title"
                class="d-flex justify-start pl-9 pl-sm-3 py-3 pa-md-0 pl-md-3"
                :class="[{ 'v-tab--active': currentStep > i }]"
            >
                <v-icon left class="mr-0 mr-sm-3 mr-lg-3" v-html="step.icon"></v-icon>
                <p class="mb-0 text-capitalize text-left title">
                    {{ step.title }}
                </p>

                <v-icon right x-large v-if="$vuetify.breakpoint.smAndUp">
                    mdi-chevron-right
                </v-icon>
            </v-tab>
        </template>
    </div>
    <v-tab
        v-else
        class="justify-space-between small-tab white "
        :class="$store.state.user.can_post_offers ? 'px-0' : 'px-3'"
    >
        <div class="text-center" :key="step.title" v-for="(step, i) in steps" style="z-index: 9">
            <v-avatar size="50" :color="currentStep > i ? 'primary' : 'grey darken-1'">
                <v-icon color="white" dark v-html="step.icon"></v-icon>
            </v-avatar>
            <p class="subtitle-2 mb-0 mx-auto" :class="{ 'grey--text text--darken-2': currentStep <= i }">
                {{ step.title }}
            </p>
        </div>
        <hr class="ts-line tegrey lighten-1" />
    </v-tab>
</template>

<script>
    export default {
        props: {
            currentStep: Number,
            orderType: String,
            isPartialMatchAllowed: Boolean,
        },
        computed: {
            steps() {
                const isPoster = this.$store.state.user.can_post_offers;
                const steps = [
                    {
                        icon: 'mdi-account-plus',
                        title: 'Add Recipient’s payment details',
                    },
                    {
                        icon: 'mdi-credit-card',
                        title: isPoster ? 'Accept This Request' : 'Accept Payment Transaction',
                    },
                ];

                if (this.orderType === '3po') {
                    return [
                        {
                            icon: 'mdi-currency-usd',
                            title: 'Select Amount',
                        },
                        ...steps
                    ];
                }

                if (this.isPartialMatchAllowed) {
                    steps.unshift({
                        icon: 'mdi-currency-usd',
                        title: 'Select Amount',
                    })
                }

                if (isPoster) {
                    return steps;
                }

                let recipientTitle = '';

                if (this.orderType === 'hybrid') {
                    recipientTitle = ' to Temporary Virtual Account';
                } else if (this.orderType !== '3po') {
                    recipientTitle = ' to Matched Peer';
                }

                return [
                    ...steps,
                    {
                        icon: 'mdi-bank-transfer',
                        title: `Make Payment${recipientTitle}`,
                    },
                ];
            },
        },
    };
</script>

<style scoped>
.tabs {
    width: 250px;
}

.tabs >>> .v-tab {
    color: #929292;
    height: 20vh !important;
    pointer-events: none;
    position: relative;
}

.tabs.isPoster >>> .v-tab {
    height: 30vh !important;
}

.tabs >>> .v-tab .v-icon {
    color: #929292 !important;
}

p.subtitle-2,
.tabs >>> .v-tab p {
    white-space: initial;
    text-transform: none;
}

p.subtitle-2 {
    line-height: 1.2;
    font-size: 0.8rem !important;
}

.isPoster p.subtitle-2 {
    width: 75%;
}

.tabs >>> .v-tab .v-icon:last-of-type {
    position: absolute;
    right: 0;
}

.tabs >>> .v-tab.v-tab--active {
    background-color: #181235;
    color: #ffffff;
}

.tabs >>> .v-tab.v-tab--active p,
.tabs >>> .v-tab.v-tab--active .v-icon {
    color: #ffffff !important;
}

.tabs >>> .small-tab:before,
.tabs >>> .v-tab.v-tab--active::before {
    background-color: transparent !important;
}

.tabs >>> .v-tab p {
    color: #929292;
    width: 75%;
}

.ts-line {
    position: absolute;
    width: 50%;
    margin: 0 auto;
    left: 25%;
    top: 33px;
    z-index: 1;
}

.isPoster .ts-line {
    top: 30px;
}

@media screen and (max-width: 767px) {
    .tabs {
        width: 100% !important;
        position: relative;
    }

    .tabs >>> .v-tab {
        height: auto !important;
    }

    .tabs >>> .v-tab .v-icon:last-of-type {
        position: relative;
    }

    .v-tab:before, .v-tabs-slider {
        background-color: #fff !important;
    }
}

@media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1366px)
  and (-webkit-min-device-pixel-ratio: 2) {
    .tabs >>> .v-tab {
        height: 11vh !important;
    }
}
</style>
